import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {User} from '@models/user';
import {environment} from '~/environments/environment';
import {EMPTY_USER, SEARCH_CITY_PARAMS, SEARCH_PARAMS} from '@models/empty';
import {AlertService} from '@services/alert.service';
import {AuthenticationService} from '@services/authentification.service';
import {Invoice} from '@models/invoice';
import {Observable, of} from 'rxjs';
import {UserSearch, UserSearchCity} from '@models/search';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    updateRun = null;

    constructor(private http: HttpClient, private alertService: AlertService, public authenticationService: AuthenticationService) {
    }

    cleanInput(user: User) {
        const model = EMPTY_USER;

        Object.keys(model).forEach(key => {
            if (typeof model[key] === 'number') {
                if (isNaN(user[key])) {
                    user[key] = 0;
                } else if (typeof user[key] === 'undefined') {
                    user[key] = 0;
                } else if (typeof user[key] === 'string') {
                    console.log(key, user[key]);
                    if (user[key] === '') {
                        user[key] = 0;
                    } else {
                        user[key] = parseFloat(user[key]);
                    }
                }
            }
        });

        return user;
    }

    updateSettings(user: User) {
        if (this.updateRun != null) {
            clearTimeout(this.updateRun);
        }
        $('#typing').fadeIn();
        $('#saved').hide();


        const t = this;
        this.updateRun = setTimeout(() => {
            user = this.cleanInput(user);
            if (user.part_arrangment + user.part_equipment + user.part_facade + +user.part_structure !== 100) {
                this.alertService.error('Le total est different de 100%');
            } else {
                user = t.cleanInput(user);
                this.http.put(environment.apiUrl + 'app/user/settings', user).subscribe(result => {
                    $('#typing').hide();
                    $('#saved').fadeIn();
                    setTimeout(() => {
                        $('#saved').fadeOut();
                    }, 3000);
                    this.authenticationService.setUser(user);
                    console.log('Success update');
                    console.log(user);
                }, error => {
                    console.log('Error update');
                    console.log(error);
                });
            }
        }, 2000);
    }

    updateAccount(user: User) {
        if (this.updateRun != null) {
            clearTimeout(this.updateRun);
        }
        $('#typing').fadeIn();
        $('#saved').hide();

        const t = this;
        this.updateRun = setTimeout(() => {
            user = t.cleanInput(user);
            this.http.put(environment.apiUrl + 'app/user', user).subscribe(result => {
                $('#typing').hide();
                $('#saved').fadeIn();
                setTimeout(() => {
                    $('#saved').fadeOut();
                }, 3000);
                this.authenticationService.setUser(user);
                console.log('Success update');
            }, error => {
                if (error === 'Bad Request') {
                    this.alertService.error('Modification impossible, un compte existe avec ce mail');
                } else {
                    this.alertService.error(error);
                }
            });
        }, 1000);
    }

    updateDashboard(user: User) {
        if (this.updateRun != null) {
            clearTimeout(this.updateRun);
        }

        const t = this;
        this.updateRun = setTimeout(() => {
            this.http.put(environment.apiUrl + 'app/user/dashboard', user.user_dashboard).subscribe(result => {
                console.log('Success update');
            }, error => {
                this.alertService.error(error);
            });
        }, 1000);
    }

    updateOnboarding(user: User) {
        if (this.updateRun != null) {
            clearTimeout(this.updateRun);
        }

        const t = this;
        this.updateRun = setTimeout(() => {
            this.http.put(environment.apiUrl + 'app/user/onboarding', user.user_onboarding).subscribe(result => {
                console.log('Success update');
            }, error => {
                this.alertService.error(error);
            });
        }, 1000);
    }

    updatePassword(password) {
        this.http.put(environment.apiUrl + 'app/user/password', {
            old_password: password.old_password,
            new_password: password.new_password,
            new_password2: password.new_password2,
        }).subscribe(result => {
            console.log('Success update');
        }, error => {
            if (error === 'Bad Request') {
                this.alertService.error('Modification impossible, le mot de passe est incorrect');
            } else {
                this.alertService.error(error);
            }
        });
    }

    getInvoice(): Observable<Invoice[]> {
        return this.http.get<Invoice[]>(environment.apiUrl + 'app/user/invoice');
    }

    getInvoiceLink(invoice: Invoice): Observable<any> {
        return this.http.get<any>(environment.apiUrl + 'app/user/invoice/'+invoice.invoice_id);
    }

    getFilleul(): Observable<User[]> {
        return this.http.get<User[]>(environment.apiUrl + 'app/user/filleul');
    }

    cancelPlan(): Observable<any> {
        return this.http.delete<any>(environment.apiUrl + 'app/user/plan');
    }

    userRate(rate): Observable<any> {
        return this.http.post<any>(environment.apiUrl + 'app/user/rate', rate);
    }

    answerForm(info): Observable<any> {
        return this.http.post<any>(environment.apiUrl + 'app/user/form', info);
    }

    closeNewsForm(): Observable<any> {
        return this.http.post<any>(environment.apiUrl + 'app/user/news', {});
    }

    closePopupEndtrial(): Observable<any> {
        return this.http.post<any>(environment.apiUrl + 'app/user/endtrial', {});
    }

    closeVideoForm(): Observable<any> {
        return this.http.post<any>(environment.apiUrl + 'app/user/video', {});
    }

    closeHeaderForm(): Observable<any> {
        return this.http.post<any>(environment.apiUrl + 'app/user/header', {});
    }

    increaseOnboarding(user: User): Observable<any> {
        return this.http.put<User>(environment.apiUrl + 'app/user/trial', {});
    }

    hidePromo(user: User): Observable<any> {
        return this.http.put<User>(environment.apiUrl + 'app/user/promo', {});
    }

    getCurrentSearch(): Observable<UserSearch> {
        const str = localStorage.getItem('lybox_currentsearch');
        if (str === '' || str === null) {
            var currentSearch: UserSearch = ({} as UserSearch);
            currentSearch.search_ad_params = SEARCH_PARAMS;
            return of(currentSearch);
        }
        const search = JSON.parse(str) as UserSearch;

        return of(search);
    }

    setCurrentSearch(search: UserSearch) {
        const s = JSON.stringify(search);
        localStorage.setItem('lybox_currentsearch', s);
        return of(search);
    }

    /**
     * Mock from API
     */
    getCurrentSearchCity(): Observable<UserSearchCity> {
        const str = localStorage.getItem('lybox_currentsearchCity');
        if (str === '' || str === null) {
            var currentSearch: UserSearchCity = ({} as UserSearchCity);
            currentSearch.search_city_params = SEARCH_CITY_PARAMS;
            return of(currentSearch);
        }
        const search = JSON.parse(str) as UserSearchCity;

        return of(search);
    }

    setCurrentSearchCity(search: UserSearchCity) {
        const s = JSON.stringify(search);
        localStorage.setItem('lybox_currentsearchCity', s);
        return of(search);
    }

    getExport(user: User) {
        if (user.pro_plan == 'purpleimmobilier') {
            return 'purple';
        }
        if (user.pro_plan != '') {
            return user.pro_plan;
        }

        // Formateur
        if (user.code_parrainage == 'SEBMORE') {
            return 'sebmore';
        }
        if (user.code_parrainage == 'INVEST_PRENEUR') {
            return 'invest_preneur';
        }

        // // A verifier
        // if (user.pro_plan == 'smart-investissement') {
        //     return 'smart_invest';
        // }

        // Licence chasseur
        if (user.email == 'nicolas@cedricberthelon.fr' && user.plan == "pro") {
            return 'cedric_berthelon';
        } if (user.email == 'nicolas@eightcorp.fr' && user.plan == "pro") {
            return 'eightcorp';
        }
        if (user.email == 'Agence@bienserein.fr' && (user.plan == "pro" || user.plan == "gold")) {
            return 'bienserein';
        }
        if (user.email == 'quentin@regi-immo.fr' && user.plan == "pro") {
            return 'regi-immo';
        }
        if (user.email == 'nicolas@jacquet-investissement.fr' && user.plan == "pro") {
            return 'jacquet_investissement';
        }
        if (user.email === 'contact@perspectivepatrimoine.com' && user.plan == "pro") {
            return 'perspective_patrimoine';
        }
        if (user.email === 'mandin.bellens@hevrest.com' && user.plan == "pro") {
            return 'hevrest';
        }
        if (user.email === 'delil.torgursul@gmail.com' && user.plan == "pro") {
            return 'td_conseil';
        }
        if (user.email === 'gestion@dakeys.fr' && user.plan == "pro") {
            return 'dakeys';
        }
        if (user.email === 'elise@cabinet-rostaing.com' && user.plan == "pro") {
            return 'cabinet-rostaing';
        }
        if (user.email.includes('@projetlocatif.fr') && user.plan == "pro") {
            return 'projetlocatif';
        }
        if ((user.email === 'syllalamina0@gmail.com' && user.plan == "pro")) {
            return 'leducationfinanciere';
        }
        if (user.email === 'will.synesius@nr-immobilier.com' && user.plan == "pro") {
            return 'naturellementriche';
        }
        if (user.email === 'contact@learn-immo.fr' && user.plan == "pro") {
            return 'learnimmo';
        }
        if (user.email == 'thomas@lecoindulmnp.fr' && user.plan == "pro") {
            return 'joust';
        }
        if (user.email == 'alexandre.bretton@baluchon.co' && user.plan == "pro") {
            return 'baluchon';
        }
        if (user.email == 'antoine@valuo.immo' && user.plan == "pro") {
            return 'valuo';
        }
        if (user.email == 'pascal.blenner@label-vie.fr' && user.plan == "pro") {
            return 'wao';
        }
        if (user.email == 'contact@kgimmobilier.fr' && user.plan == "pro") {
            return 'kgimmobilier';
        }
        if (user.email == 'egenet@pileapartners.fr' && user.plan == "pro") {
            return 'pileapartners';
        }
        if (user.email == 'gregimmo.invest@gmail.com' && user.plan == "pro") {
            return 'greginvest';
        }
        if (user.email == 'Olivier@so7.fr' && user.plan == "pro") {
            return 'so7';
        }
        if (user.email == 'mathieu.vaudolon@gmail.com' && user.plan == "pro") {
            return 'skelo';
        }
        if (user.email == 'cg2i.team@gmail.com' && user.plan == "pro") {
            return 'cg2i';
        }
        return 'lybox';
    }

    getPromo(user) {
        // let promo = 'rentree'
        // if (user.pro_plan != "") {
        //     promo = '';
        // }
        // if (user.plan == "pro") {
        //     promo = '';
        // }
        // if (user.plan == "expert" && user.subscription && user.subscription.duration == "year") {
        //     promo = '';
        // }
        // if (promo != '') {
        //     return promo;
        // }

        if (this.authenticationService.showPromo() == true) {
           return 'onboarding';
        } else if (user.code_parrainage == 'TONY' || user.code_parrainage == 'JM' || user.code_parrainage == 'PAULINE' || user.code_parrainage == 'THEO') {
            return  'partner_1month';
        } else if (user.code_parrainage == 'PROJETLOCATIF' && user.subscription.subscription_id == '') {
            return  'projetlocatif'; // -20%
        } else if (user.code_parrainage != '' && user.code_parrainage != 'PROJETLOCATIF' && !this.authenticationService.isAffiliate(user) && user.subscription.subscription_id == '') {
            return 'parrain';
        } else if (this.authenticationService.isAffiliate(user) && user.subscription.subscription_id == '' && this.authenticationService.getInfluenceur(user).discount > 0) {
            return 'partner';
        }

        return '';
    }

    getPrice(plan, duration, user, promo) {

        let discount = 0;
        if (promo == 'bf') {
            discount = 50;
        } else if (promo == 'partner') {
            discount = this.authenticationService.getInfluenceur(user).discount;
        } else if (promo == 'projetlocatif' || promo == 'onboarding') {
            discount = 20;
        } else if (promo == 'rentree') {
            discount = 30;
        }

        if (duration == 'year') {
            if (user.p == '0' || user.p == '1') {
                if (plan == 'basique') {
                    return [16.58 * (1 - (discount / 100)), 16.58, 0];
                } else if (plan == 'essentiel') {
                    return [33.25 * (1 - (discount / 100)), 33.25, 0];
                } else if (plan == 'expert') {
                    return [49.91 * (1 - (discount / 100)), 49.91, 0];
                }
            } else if (user.p == '3') {
                if (plan == 'basique') {
                    return [9 * (1 - (discount / 100)), 9, 0];
                } else if (plan == 'essentiel') {
                    return [24 * (1 - (discount / 100)), 24, 0];
                } else if (plan == 'expert') {
                    return [49 * (1 - (discount / 100)), 49, 0];
                }
            }
        } else if (duration == 'quarter') {
            if (user.p == '0' || user.p == '1') {
                if (plan == 'basique') {
                    return [18.2 * (1 - (discount / 100)), 18.2, 20];
                } else if (plan == 'essentiel') {
                    return [36.6 * (1 - (discount / 100)), 36.6, 40];
                } else if (plan == 'expert') {
                    return [54.9 * (1 - (discount / 100)), 54.9, 60];
                }
            } else if (user.p == '3') {
                if (plan == 'basique') {
                    return [10 * (1 - (discount / 100)), 10, 12];
                } else if (plan == 'essentiel') {
                    return [27 * (1 - (discount / 100)), 27, 36];
                } else if (plan == 'expert') {
                    return [54 * (1 - (discount / 100)), 54, 60];
                }
            }
        } else if (duration == 'month') {
            if (user.p == '0' || user.p == '1') {
                if (plan == 'basique') {
                    return [19.9 * (1 - (discount / 100)), 19.9, 40];
                } else if (plan == 'essentiel') {
                    return [39.9 * (1 - (discount / 100)), 39.9, 80];
                } else if (plan == 'expert') {
                    return [59.9 * (1 - (discount / 100)), 59.9, 120];
                }
            } else if (user.p == '3') {
                if (plan == 'basique') {
                    return [11 * (1 - (discount / 100)), 11, 24];
                } else if (plan == 'essentiel') {
                    return [29 * (1 - (discount / 100)), 29, 60];
                } else if (plan == 'expert') {
                    return [59 * (1 - (discount / 100)), 59, 120];
                }
            }
        }
        return [0,0,0];
    }
}
